/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { forwardRef } from 'react';

import ConfidenceLabel, { ConfidenceLabelProps } from '../ConfidenceLabel';
import styles from './Input.module.css';

export type InputProps = ConfidenceLabelProps & {
  ignored?: boolean;
  error?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, confidenceAutomated, confidenceLevel, confidenceValue, ignored, error, ...rest }: InputProps, ref) => {
    const isDisabled = ignored || rest.disabled;

    const disabledClassName = isDisabled || rest.readOnly ? styles['input-append-disabled'] : '';
    const automatedClassName = confidenceAutomated ? ' automated' : '';
    const ignoredClassName = ignored ? ' ignored' : '';
    const extraClassNames = className ? ` ${className}` : '';
    const errorClassName = error ? ` ${styles.error}` : '';
    const classNames = `form-control form-control-appended${automatedClassName}${extraClassNames}${ignoredClassName}${errorClassName} ${styles.input}`;

    const focusInput = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      // eslint-disable-next-line
      // @ts-expect-error
      event.target.previousSibling?.focus();
    };

    return (
      <div className="input-group input-group-merge">
        <input type="text" className={classNames} ref={ref} {...rest} disabled={isDisabled} />
        {confidenceAutomated ? (
          <span className={`${styles['badge-automated']} ${styles['badge-label']}`} onClick={focusInput}>
            Automated
          </span>
        ) : null}
        {ignored ? (
          <span className={`${styles['badge-ignored']} ${styles['badge-label']}`} onClick={focusInput}>
            NOT IN DOCUMENT
          </span>
        ) : null}
        <div className={`input-group-append${errorClassName}`}>
          <div
            className={`input-group-text${automatedClassName}${ignoredClassName}${errorClassName} ${disabledClassName}`}
          >
            <ConfidenceLabel
              confidenceAutomated={confidenceAutomated}
              confidenceLevel={confidenceLevel}
              confidenceValue={confidenceValue}
              ignored={ignored}
            />
          </div>
        </div>
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
